import React, { useEffect, useState } from "react";
import product from "../../Images/prdctimg.png";
import "./ModalNew.css";

const ProductModal = ({ closemodal }) => {
    return (
        <>
            <div className="productmodal">
                <div className="productmodalcontent">
                    <div className="icklohjj" onClick={() => closemodal()}>
                        <i
                            className="fa-solid fa-xmark"
                            style={{ cursor: "pointer" }}
                        ></i>
                    </div>
                    <div className="">
                        <div className="prcdgimgj">
                            <img src={product} alt="..." />
                        </div>
                        <div className="divtstxmodal">
                            <h4 className="prdcttctx">NFC Card</h4>
                            <p className="unjktxtt">At Neoo search, we truly believe in the importance of nurturing connections. We understand that people are much more than what can be summarized on a piece of paper. That's why we have developed a platform</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProductModal